import { createContext } from 'react'
import type { SchoolModuleKey } from '@/features/school/modules'
import type { CurrentUser, LoginInput, Permission, Portal, SchoolSummary, Session } from './types'

export type AuthStatus = 'loading' | 'authenticated' | 'anonymous'

export interface AuthContextValue {
  status: AuthStatus
  user: CurrentUser | null
  school: SchoolSummary | null
  portal: Portal | null
  login: (input: LoginInput) => Promise<Session>
  logout: () => Promise<void>
  can: (permission: Permission) => boolean
  /** Whether the school uses an optional module (turned on by the platform operator). */
  hasModule: (module: SchoolModuleKey) => boolean
  setUser: (user: CurrentUser) => void
  /** Updates the signed-in school (e.g. after its settings change). */
  setSchool: (school: SchoolSummary) => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)
